import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';

import './Weight.sass';

interface FormWeightProps {
	value?: number;
	count?: number;
	dark?: boolean;
	disabled?: boolean;
	onChange?: (value: number) => void;
}

function FormWeight(props: FormWeightProps) {
	const value = props.value || 0;
	const max = props.count || 3;

	const change = () => {
		if (props.disabled) return;

		let newValue = isNaN(value) ? 1 : value + 1;

		if (newValue > max) {
			newValue = 1;
		}

		if (props.onChange) {
			props.onChange(newValue);
		}
	}

	return (
		<div
			className={[
				'Weight',
				props.dark === true ? 'dark' : 'light',
				props.count === 1 ? 'single' : '',
				props.disabled ? 'disabled' : ''
			].join(' ')}
			onClick={change}
		>
			<div
				className={
					value >= 1 ? 'filled' : ''
				}
			>
				{(!props.count || props.count === 1) && (
					<FontAwesomeIcon icon={faCheck as any} />
				)}
			</div>
			{(!props.count || props.count > 1) && (
				<div
					className={
						value >= 2 ? 'filled' : ''
					}
				>
					{(!props.count || props.count === 1) && (
						<FontAwesomeIcon icon={faCheck as any} />
					)}
				</div>
			)}
			{(!props.count || props.count > 2) && (
				<div
					className={
						value >= 3 ? 'filled' : ''
					}
				>
					{(!props.count || props.count === 1) && (
						<FontAwesomeIcon icon={faCheck as any} />
					)}
				</div>
			)}
		</div>
	);
}

export default FormWeight;
